'use client';

import { SectLabel, SectH2 } from '@/components/landing/v4-shared';
import { V4EnterGrid } from '@/components/landing/V4EnterGrid';
import { AeoTrackedFaqItem } from '@/components/ai-receptionist/aeo-instrumentation';
import { type AeoPageFamily } from '@/lib/analytics/enhanced-events';

export function FaqSection({
  faqs,
  analyticsPageFamily,
}: {
  faqs: ReadonlyArray<{ readonly q: string; readonly a: string }>;
  analyticsPageFamily?: AeoPageFamily;
}) {
  return (
    <section
      aria-labelledby="faq-heading"
      className="max-w-[960px] mx-auto px-6"
      style={{ marginBottom: 56 }}
    >
      <SectLabel color="var(--cyan-glow)">FAQ</SectLabel>
      <SectH2 id="faq-heading" style={{ fontSize: 'clamp(28px, 3.6vw, 44px)' }}>
        Frequently Asked Questions About AI Receptionists
      </SectH2>
      <V4EnterGrid
        className="v4-enter v4-stagger"
        style={{ display: 'grid', gap: 12, marginTop: 24 }}
      >
        {faqs.map((faq, index) => (
          analyticsPageFamily ? (
            <AeoTrackedFaqItem
              key={faq.q}
              question={faq.q}
              answer={faq.a}
              position={index + 1}
              pageFamily={analyticsPageFamily}
            />
          ) : (
            <details key={faq.q} className="v4-faq">
              <summary>{faq.q}</summary>
              <div className="v4-faq__answer speakable-answer">{faq.a}</div>
            </details>
          )
        ))}
      </V4EnterGrid>
    </section>
  );
}
